module.exports = __webpack_public_path__ + "img/久保健輔.e1dd0be5.jpg";